/**
 * Original idea for this provider came from:
 * https://nextsteps.dev/apollo-client-graphQL-and-auth
 */

import React from 'react';
import PropTypes from 'prop-types';
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache,
  from,
} from '@apollo/client';
import { useAuth0 } from '@auth0/auth0-react';

const AuthorizedApolloProvider = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();

  const customFetch = async (_, options) => {
    const { operationName } = JSON.parse(options.body);
    const token = await getAccessTokenSilently();
    const modifiedOptions = {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
    };

    return fetch(
      `${window.config.GRAPHQL_URI}?operation=${operationName}`,
      modifiedOptions
    );
  };

  const httpLink = createHttpLink({
    fetch: customFetch,
  });

  const cache = new InMemoryCache({
    typePolicies: {
      responses: {
        fields: {
          buttons: {
            merge: false,
          },
          user_goal: {
            merge: false,
          },
          gallery_items: {
            merge: false,
          },
        },
      },
      gallery_items: {
        fields: {
          buttons: {
            merge: false,
          },
        },
      },
      users: {
        fields: {
          responses: {
            merge: false,
          },
        },
      },
    },
  });

  const apolloClient = new ApolloClient({
    link: from([httpLink]),
    cache,
  });

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

AuthorizedApolloProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export { AuthorizedApolloProvider };
